// Issue #339 — "Usar como Padrão" para objetos de desenho.
// Os defaults customizados por tipo vivem no blob do indicatorDefaultsStore
// (server-synced) sob chave namespaced para não colidir com chaves de
// indicador homônimas (ex.: "trendLine").
export const INTERACTIVE_DEFAULTS_PREFIX = "interactive:";

export const interactiveDefaultsKey = (type) =>
  `${INTERACTIVE_DEFAULTS_PREFIX}${type}`;

export const hasCustomAppearance = (custom) =>
  !!custom && Object.keys(custom).length > 0;

// Merge raso por prop: props-objeto (stroke, font, fill…) mesclam campo a
// campo sobre o registry; escalares e arrays (ex.: fibLevels) substituem
// inteiros — nunca spread de array em objeto (gotcha do PropertyTypes).
export const mergeCustomAppearance = (registryAppearance, customAppearance) => {
  const base = registryAppearance || {};
  if (!hasCustomAppearance(customAppearance)) return base;

  const merged = { ...base };
  Object.entries(customAppearance).forEach(([name, value]) => {
    const baseVal = base[name];
    if (
      value &&
      typeof value === "object" &&
      !Array.isArray(value) &&
      baseVal &&
      typeof baseVal === "object" &&
      !Array.isArray(baseVal)
    ) {
      merged[name] = { ...baseVal, ...value };
    } else {
      merged[name] = value;
    }
  });
  return merged;
};

// Precedência de cor para objeto NOVO: default salvo por tipo vence o swatch
// global. Retorna null quando há default salvo — a cor efetiva passa a vir da
// aparência mesclada (registry ← default salvo).
export const resolveDrawingColor = (customAppearance, currentDrawingColor) =>
  hasCustomAppearance(customAppearance) ? null : currentDrawingColor;
